import React from 'react';
export function DashboardShimmer() {
  return <div className="space-y-6 animate-pulse" data-id="element-4153">
      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-4154">
        {[1, 2, 3, 4].map(i => <div key={i} className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-4155">
            <div className="flex justify-between items-start mb-4" data-id="element-4156">
              <div className="h-4 w-32 bg-gray-200 rounded" data-id="element-4157" />
              <div className="w-10 h-10 bg-gray-200 rounded-md" data-id="element-4158" />
            </div>
            <div className="h-8 w-40 bg-gray-200 rounded mb-2" data-id="element-4159" />
            <div className="h-3 w-24 bg-gray-200 rounded" data-id="element-4160" />
          </div>)}
      </div>
      {/* Charts Row */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-4161">
        {[1, 2].map(i => <div key={i} className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-4162">
            <div className="flex justify-between items-center mb-4" data-id="element-4163">
              <div className="h-5 w-32 bg-gray-200 rounded" data-id="element-4164" />
              <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-4165" />
            </div>
            <div className="h-64 bg-gray-200 rounded-md" data-id="element-4166" />
          </div>)}
      </div>
      {/* Activity Section */}
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-4167">
        <div className="h-5 w-40 bg-gray-200 rounded mb-4" data-id="element-4168" />
        <div className="space-y-3" data-id="element-4169">
          {[1, 2, 3, 4, 5].map(i => <div key={i} className="flex items-center gap-4 p-3 border border-gray-200 rounded-lg" data-id="element-4170">
              <div className="w-10 h-10 bg-gray-200 rounded-full" data-id="element-4171" />
              <div className="flex-1 space-y-2" data-id="element-4172">
                <div className="h-4 w-64 bg-gray-200 rounded" data-id="element-4173" />
                <div className="h-3 w-32 bg-gray-200 rounded" data-id="element-4174" />
              </div>
              <div className="h-4 w-20 bg-gray-200 rounded" data-id="element-4175" />
            </div>)}
        </div>
      </div>
    </div>;
}